/* eslint-disable @typescript-eslint/ban-types */
import { DatePicker } from 'antd';
import {
  filterData,
  setFilterData,
} from 'common/commonRedux/feature/filteringSlice';
import { RootState } from 'common/redux/store';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
type SingleDateSelectType = {};
const SingleDateSelect: React.FC<SingleDateSelectType> = () => {
  const getFilterData = useSelector(filterData);
  const { format } = useSelector((state: RootState) => state.dateFormatter);
  const dispatch = useDispatch();

  const handleDateChange = (date: any) => {
    if (date) dispatch(setFilterData({ singleDate: date }));
  };

  return (
    <>
      <DatePicker
        value={getFilterData?.singleDate}
        onChange={handleDateChange}
        format={format}
        className="h-[35px]"
        disabledDate={(current) => {
          return current && current > dayjs().endOf('day');
        }}
        popupClassName="filtering-top-bar-dropdown"
      />
    </>
  );
};

export default SingleDateSelect;
